import { Header } from '@tanstack/react-table'

export const isLeaf = (header: Header<unknown, unknown>) => {
    return header.subHeaders.length === 0
}
